/**
 * Emoji Picker Component
 * Simple emoji picker for message reactions
 */

import React from 'react';

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

const EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onSelect, onClose }) => {
  return (
    <div className="absolute bottom-full left-0 mb-2 bg-white border border-gray-200 rounded-lg shadow-lg p-2 z-50 flex gap-1">
      {EMOJIS.map((emoji) => (
        <button
          key={emoji}
          onClick={() => {
            onSelect(emoji);
            onClose();
          }}
          className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded transition-colors text-lg"
          title={emoji}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
};

export default EmojiPicker;

